var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsxs, jsx } from "react/jsx-runtime";
import { arc } from "d3-shape";
import PropTypes from "prop-types";
import { Component, cloneElement } from "react";
import { textLight } from "./tokens.esm.js";
const getIdentifierFromReactNode = (node) => typeof node === "string" ? node : node.props.id;
class Arc extends Component {
  render() {
    const {
      props
    } = this;
    const arcFn = arc().innerRadius(props.innerRadius).outerRadius(props.outerRadius).startAngle(props.startAngle).endAngle(props.endAngle);
    const radius = props.outerRadius;
    const dist = radius + 20;
    const angle = (props.startAngle + props.endAngle) / 2 + props.labelOffset;
    const x = dist * Math.sin(angle);
    const y = -dist * Math.cos(angle);
    const anchor = x > 0 ? "start" : "end";
    const t = `translate(${x},${y - 10})`;
    const tlabel = `translate(${x},${y + 10})`;
    const arcLabelTextStyle = {
      textAnchor: anchor,
      fill: textLight,
      shapeRendering: "crispEdges",
      fontSize: "11px"
    };
    const arcLabelValueStyle = {
      textAnchor: anchor,
      fill: props.labelTextFill,
      shapeRendering: "crispEdges",
      fontWeight: "bold"
    };
    let underline;
    if (this.props.label.props && this.props.label.props.hasUnderline) {
      underline = /* @__PURE__ */ jsx("path", { transform: tlabel, d: "M -2 -16 L 23.34375 -16", stroke: "black", strokeWidth: "1", strokeDasharray: "1 3" });
    }
    return /* @__PURE__ */ jsxs("g", { className: "arc-group", children: [
      /* @__PURE__ */ jsx("path", { className: "arc", d: arcFn(), fill: props.fill }),
      !this.props.hideLabels ? /* @__PURE__ */ jsxs("g", { className: "arc-label-group", "data-key": props.dataKey, children: [
        typeof props.label === "string" ? /* @__PURE__ */ jsx("text", { className: "arc-label-text", transform: t, "data-label": getIdentifierFromReactNode(props.label), style: arcLabelTextStyle, children: props.label }) : cloneElement(props.label, {
          className: "arc-label-text",
          transform: t,
          "data-label": getIdentifierFromReactNode(props.label),
          style: arcLabelTextStyle
        }),
        underline,
        /* @__PURE__ */ jsx("text", { className: "arc-label-value", transform: tlabel, style: arcLabelValueStyle, children: props.valueFormatter(props.value) })
      ] }) : null
    ] });
  }
}
__publicField(Arc, "propTypes", {
  d: PropTypes.string,
  endAngle: PropTypes.number.isRequired,
  fill: PropTypes.string,
  label: PropTypes.node,
  labelOffset: PropTypes.number,
  labelTextFill: PropTypes.string,
  outerRadius: PropTypes.number.isRequired,
  startAngle: PropTypes.number.isRequired,
  value: PropTypes.number,
  valueFormatter: PropTypes.func,
  valueTextFill: PropTypes.string,
  dataKey: PropTypes.any,
  hideLabels: PropTypes.bool,
  innerRadius: PropTypes.number.isRequired
});
__publicField(Arc, "defaultProps", {
  label: "",
  labelOffset: 0,
  fill: "purple",
  labelTextFill: "black",
  valueTextFill: "white"
});
export {
  Arc as default
};
